import React, { useState } from "react";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import Modal from "react-bootstrap/Modal";

const SearchForm = ({ dataSearch, onChangeData, onChangeDate, onSearch, handleKeyDown }) => {
    const [showModal, setShowModal] = useState(false);
    const toggleModal = () => setShowModal(!showModal);

    const handleSearch = () => {
        onSearch();
        if (showModal) {
            toggleModal();
        }
    }
    const renderFormFields = () => (
        <>
            <div className="input-sm-new input-new-18">
                <label htmlFor="SearchText" className="font-color-default font-bold">Tìm kiếm</label>
                <input
                    id="SearchText"
                    type="text"
                    className="form-control input-sm"
                    placeholder="Khách hàng/ Mã"
                    onChange={onChangeData("SearchText")}
                    onKeyDown={handleKeyDown}
                    value={dataSearch.SearchText}
                />
            </div>
            <div className="input-sm-new input-new-18">
                <label htmlFor="DateFrom" className="font-color-default font-bold">Từ ngày</label>
                <DateTimePicker
                    id="DateFrom"
                    value={dataSearch.DateFrom}
                    onChange={onChangeDate("DateFrom")}
                    placeholder="Từ ngày"
                    name="DateFrom"
                />
            </div>
            <div className="input-sm-new input-new-18">
                <label htmlFor="DateTo" className="font-color-default font-bold">Đến ngày</label>
                <DateTimePicker
                    id="DateTo"
                    value={dataSearch.DateTo}
                    onChange={onChangeDate("DateTo")}
                    placeholder="Đến ngày"
                    name="DateTo"
                />
            </div>
        </>
    );

    return (<>
        <div className="card border-light hidden-mobile-main show-table-main card-v2" style={{ marginTop: "-8px" }}>
            <div className="card-body card-body-v2">
                <div className="search-new ban-hang-search-form">
                    {renderFormFields()}
                    
                    <div className="input-sm-new input-new-18 search-main-new">
                        <button
                            type="submit"
                            className="btn btn-info-new"
                            style={{ marginTop: "25px", paddingTop: "7px" }}
                            onClick={handleSearch}
                        >
                            <i className="la la-search"></i>
                            <span> &nbsp; Tìm kiếm</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div className="repeater-default hide-table-main show-mobile-main hidden-des-main">
            <div className="col-sm-12">
                <div className="form row">
                    <div className="col-12">
                        <button
                            type="button"
                            className="btn btn-info-new"
                            onClick={toggleModal}
                        >
                            Tìm kiếm <i className="la la-search"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <Modal
            show={showModal}
            onHide={toggleModal}
            dialogClassName="modal-lg"
            className="modal-new modal fade text-left"
            backdrop="static"
        >
            <Modal.Header>
                <h2 className="modal-title p-1">
                    Tìm kiếm
                </h2>
                <button type="button" className="close-popup-new" onClick={toggleModal}>
                    <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
                </button>
            </Modal.Header>
            <Modal.Body>
                <div>
                    {renderFormFields()}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button
                    type="button"
                    className="btn btn-info"
                    onClick={handleSearch}
                >
                    <i className="fas fa-search"></i> Tìm kiếm
                </button>
                <button type="button" className="btn btn-info" onClick={toggleModal}>
                    <i className="fas fa-times"></i> Đóng
                </button>
            </Modal.Footer>
        </Modal>
    </>);
}

export default SearchForm;